<template>
  <v-col cols="12">
    <v-row>
      <v-col>
        <BrandButton
          variant="secondary"
          color="neutral25 text-neutral900"
          class="mr-2"
          elevation="0"
          :class="$attrs.class"
          v-bind="{...btnProps(false)}"
          @click="bulkToggleAllSelected"
        >
          <BulkSelectCheckbox
            v-if="isBulkActionsActive"
            class="mr-0 mt-0 pt-0"
            :checked="isCheckboxChecked"
          />
          <span class="text-neutral600 mr-1 ml-3">&#124;</span>
          <span>{{ $tc('bulk.action_bar.counter', numberOfSelectedItems) }}</span>
        </BrandButton>
        <DropdownHybrid
          v-if="numberOfSelectedItems > 0"
          ref="dropdown"
          v-model="dropdownOpen"
          :sheet-title="$t('bulk.action_bar.options')"
          :menu-props="{location: 'bottom', minWidth: 240}"
        >
          <template #activator="{ props }">
            <BrandButton
              variant="secondary"
              color="neutral25 text-neutral900"
              elevation="0"
              :class="$attrs.class"
              v-bind="{...props, ...btnProps()}"
            >
              <PhDotsThreeVertical class="text-h5" />
              <span v-if="!isCompact" class="ml-3">{{ $t('bulk.action_bar.options') }}</span>
            </BrandButton>
          </template>

          <v-list bg-color="neutral25" class="py-3">
            <v-list-item v-for="option in options" :key="option.key" @click="onSelect(option.action)">
              <template #prepend>
                <component :is="option.icon" class="text-h5 mr-3" :class="option.color" :weight="option.weight" />
              </template>

              <v-list-item-title :class="`${option.color} font-weight-medium`">
                {{ $tc(option.text, numberOfSelectedItems) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </DropdownHybrid>
      </v-col>
      <v-col cols="auto">
        <BrandButton
          variant="secondary"
          color="neutral25 text-neutral900"
          elevation="0"
          :class="$attrs.class"
          v-bind="{...btnProps()}"
          @click="toggleBulkActions"
        >
          <PhX class="text-h5" />
          <span v-if="!isCompact" class="ml-3">{{ $t('bulk.action_bar.exit') }}</span>
        </BrandButton>
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'
import {
  PhX,
  PhDotsThreeVertical,
} from '@phosphor-icons/vue'
import { useBulkActionsV2 } from '@/composables/useBulkActionsV2'
import { useToolbarButtonStyle } from '@/composables/useToolbarButtonStyle'
import BulkSelectCheckbox from '@/components/BulkSelectCheckbox.vue'

// TODO: instead of isCollection, isDeleted make the number of items as prop
const props = defineProps({
  options: {
    required: true,
    type: Array,
  },
  isCollection: {
    required: false,
    type: Boolean,
    default: false,
  },
  isDeleted: {
    required: false,
    type: Boolean,
    default: false,
  },
})

const { isCompact } = useToolbarButtonStyle()
const dropdown = ref(null)
const dropdownOpen = ref(false)

const {
  isBulkActionsActive,
  bulkIsAllSelected,
  bulkToggleAllSelected,
  toggleBulkActions,
  bulkNumberOfItems,
  numberOfCollections,
  isCheckboxChecked
} = useBulkActionsV2()

const numberOfSelectedItems = computed(() => {
  if (props.isCollection) {
    return numberOfCollections.value
  }
  return bulkNumberOfItems.value
})

function btnProps(collapse = true) {
  if (!isCompact.value) {
    return { rounded: true, size: 'x-large' }
  }

  if (!collapse) {
    return { height: 45, rounded: true }
  }

  return { height: 45, width: 45, icon: true }
}

function onSelect(cb) {
  dropdown.value?.close()
  cb()
}
</script>
